import { render, staticRenderFns } from "./TransferRecords.vue?vue&type=template&id=b2906644&scoped=true&"
import script from "./TransferRecords.vue?vue&type=script&lang=js&"
export * from "./TransferRecords.vue?vue&type=script&lang=js&"
import style0 from "./TransferRecords.vue?vue&type=style&index=0&id=b2906644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2906644",
  null
  
)

export default component.exports